<template>
	<div>
		<Fontnavbar title="修改密码"/>
		<van-field
			v-if="phone_state=0"
			v-model="phones"
			error
			label="注册手机号"
			type="tel"
			disabled 
			maxlength="11"
		/>
		<van-field
			v-if="phone_state=1"
			v-model="phones"
			label="注册手机号"
			error
			disabled 
			maxlength="11"
			placeholder="当前没有注册手机号"
		/>
		<van-field
			v-model="phone"
			label="手机号"
			type="tel"
			maxlength="11"
			placeholder="请输入手机号"
			@input="checkPhone"
		>
			<van-button v-if="message" slot="button" disabled hairline size="small" :type="type">{{ message }}</van-button>
		</van-field>
		<van-field
			v-model="sms_code"
			center
			clearable
			label="短信验证码"
			placeholder="请输入短信验证码"
		>
			<van-button slot="button" :disabled="codeBtn" size="small" @click="sendSmsCode" type="danger">{{ codeBtnText }}</van-button>
		</van-field>
		<van-field
			v-model="password"
			label="密码"
			type="password"
			placeholder="请输入新密码"
		/>
		<van-field
			v-model="surepwd"
			label="确认密码"
			type="password"
			placeholder="请输入密码"
		/>		
		<div class="login-btn">
			<van-button round block type="danger"  @click="doRegister">
				确认修改
			</van-button>
		</div>
	</div>
</template>

<script>
import { editpwd, sendSmsCode } from '../../api.js'
import { post } from '../../request.js'
import { Button, Field, Toast } from 'vant'
import Fontnavbar from "../../components/Navbar.vue";
export default {
  components: {
    [Button.name]: Button,
		[Field.name]: Field,
		Fontnavbar
  },
	data() {
		return {
			username: '',
			password: '',
			phone: '',
			phones: '',
			yphones: '',
			email: '',
			surepwd: '',
			qq: '',
			sms_code: '',
			codeBtn: false,
			codeBtnText: '发送验证码',
			leftTime: 60,
			phone_state:1,
			message:'',
			type: 'primary'

		};
	},
	created(){
		let phones = this.$route.query.phone;
		if(phones==0){
			this.phone_state=1
		}else{
			this.phone_state=0
			this.yphones=phones
			this.phones = phones.substr(0, 3) + "****" + phones.substr(7);
			// console.log(phones)
			// console.log(this.phone)
		}
		
	},
	methods: {
		doRegister() {
			if (this.phone == '') {
				Toast('手机号不能为空')
				return false
			}
			if (this.phone.length != 11) {
				Toast('手机号格式错误')
				return false
			}
			if (this.password == '') {
				Toast('密码不能为空')
				return false
			}
			if (this.password != this.surepwd) {
				Toast('两次输入的密码不一致')
				return false
			}
			if (this.sms_code == '') {
				Toast('验证码不能为空')
				return false
			}
			if (this.message != '√'){
				Toast('手机不正确')
				return false
			}
			var that = this
			post(editpwd, {
				'phone': this.phone,
				'password': this.password,
				'surepwd': this.surepwd,
				'sms_code': this.sms_code
				}).then((res) => { 
					if (res.code == 200) {
						Toast.success(res.msg)
						setTimeout(function (){
							that.$router.go(-1);
						}, 1500)
					} else {
						Toast(res.msg)
					}
			})
		},
		
		sendSmsCode() {
			if(this.phone == '' || this.phone.length != 11){
				Toast('手机号格式错误')
				return false
			}
			if (this.message != '√'){
				Toast('手机不正确')
				return false
			}
			this.codeBtn = true
			this.codeBtnText = '剩余'+this.leftTime+'秒'
			var that = this
			var interval = setInterval(function () {
				--that.leftTime;
				that.codeBtnText = '剩余'+that.leftTime+'秒'
				if (that.leftTime <= 0) {
					clearInterval(interval)
					that.leftTime = 60
					that.codeBtn = false
					that.codeBtnText = '发送验证码'
				}
			}, 1000)
			post(sendSmsCode, {'phone': this.phone}).then(() => { })
		},
		checkPhone(number){
			if (number.length < 11){
				this.message = '';
				return;
			}
			if (number != this.yphones){
				this.type = 'danger'
				this.message = '手机号不正确';
			}else{
				this.type = 'primary'
				this.message = '√';
			}
		}
	},

	
};

</script>

<style lang="less" scoped>
.login-btn{
	margin: 15px;
}
.login-tip{
	margin:15px 15px 0;
	font-size: 14px;
	color:#f00;
	text-align: right;
}
.login-tip span{
	margin:0px 5px;
}
</style>
